import React, { useState, useEffect } from "react";
import axios from "axios";
import Login from "./components/Login";
import Register from "./components/Register";
import { Chat } from "./components/Chat";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

axios.defaults.withCredentials = true;

const App = () => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const { data } = await axios.get("/api/auth/me");
        setUser(data);
      } catch (error) {
        setUser(null);
      } finally {
        setChecking(false);
      }
    };

    loadUser();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post("/api/auth/logout");
    } finally {
      setUser(null);
    }
  };

  if (checking) return <p className="text-center mt-5">Loading...</p>;

  return (
    <div className="app">
      <div className="d-flex justify-content-between align-items-center px-4">
        <h1>Chat App</h1>
        {user && (
          <button className="btn btn-outline-danger" onClick={handleLogout}>
            Logout
          </button>
        )}
      </div>
      {!user ? (
        <div className="container mt-5 text-center">
          <div className="row">
            <div className="col-md-6">
              <Register setUser={setUser} />
            </div>
            <div className="col-md-6">
              <Login setUser={setUser} />
            </div>
          </div>
        </div>
      ) : (
        <Chat user={user} />
      )}
    </div>
  );
};

export default App;
